<template>
  <router-view :dbList="this.dbList" :indexList="this.indexList" :listLimit="this.listLimit"></router-view>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src

import i18n from '@/i18n.js'

export default {
  name: 'en',
  props: {
    dbList: { type: Array, required: true },
    indexList: { type: Array, required: true },
    listLimit: { type: Array, required: true },
  },
  created () {
    i18n.locale = 'en'
  }
}
</script>